module.exports = "<p>  I agree, that Bonfire uses my email address,\n  to send recurrently informations about the development of the game by email.\n  I can always decline that agreement via email by sending a short notice to <a href=\"mailto:hello@bonfire-game.com\">hello@bonfire-game.com</a>.</p>\n<p>  We use Mailchimp as our marketing platform. By clicking &quot;ok&quot;, you acknowledge that your information \n  will be transferred to Mailchimp for processing.</p>\n<p>  <a href=\"https://mailchimp.com/legal\">Learn more about Mailchimp&#39;s privacy practices here</a>.</p>\n";


//////////////////
// WEBPACK FOOTER
// ./src/content/newsletter-agreement.md
// module id = 375
// module chunks = 0